import React, { useEffect, useState, FormEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Formulario, { FormField } from "../../../../components/Formulario";
import { getFabricanteById, updateFabricante } from "../../../../api/fabricanteApi";
import { Modelo } from "../../../../types/fabicante";

const EditarFabricante: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [descricaoFabricante, setDescricaoFabricante] = useState<string>("");
  const [modelos, setModelos] = useState<Modelo[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [updating, setUpdating] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFerramenta = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const fabricanteData = await getFabricanteById(token, id!);
        setDescricaoFabricante(fabricanteData.descricao_fabricante);
        setModelos(fabricanteData.modelos)
      } catch (error) {
        toast.error("Erro ao buscar fabricante!");
        console.error("Erro ao buscar fabricante:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFerramenta();
  }, [id]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setUpdating(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      await updateFabricante(token, id!, {
        descricao_fabricante: descricaoFabricante,
      });
      toast.success("Fabricante atualizado com sucesso!");
      navigate("/fabricantes");
    } catch (error) {
      toast.error("Erro ao atualizar Fabricante!");
      console.error("Erro ao atualizar Fabricante:", error);
    } finally {
      setUpdating(false);
    }
  };

  const handleBack = () => {
    navigate("/fabricantes");
  };

  const fields: FormField[] = [
    {
      label: "Descrição do Fabricante",
      type: "text",
      value: descricaoFabricante,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setDescricaoFabricante(e.target.value),
    },
  ];

  return (
    <>
      <Formulario
        title="Editar Fabricante"
        fields={fields}
        onSubmit={handleSubmit}
        onBack={handleBack}
        loading={loading || updating}
      />
      <>
        <Box sx={{ p: 3 }}>
          <Typography variant="h6">Modelos Cadastrados:</Typography>
          {modelos.length === 0 ? (
            <Typography variant="body1">Nenhum modelo cadastrado.</Typography>
          ) : (
            <TableContainer component={Box} sx={{ maxHeight: 400 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Descrição do Modelo</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {modelos.map((modelo: Modelo) => (
                    <TableRow key={modelo.id}>
                      <TableCell>{modelo.id}</TableCell>
                      <TableCell>{modelo.descricao_modelo}</TableCell>    
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </>
    </>
  );
};

export default EditarFabricante;
